<template>
  <div :class="['default-image-box', zoomClass?'img-zoom':'']">
    <img :src="finalSrcImg" alt="" />
  </div>
</template>

<script>
export default {
    name: 'DefaultImageBox',
    data() {
        return {
            finalSrcImg : '',
        }
    },
    watch: {
        src: function (val) {
            this.handleSrcChange(val)
        }
    },
    props: {
        //图片路径
        src: {
            type: String,
            default: ''
        },
        //主图片没有时的默认图片
        defaultSrc: {
            type: String,
            default: ''
        },
        //图片宽度
        width: {
            type: String,
            default: '100%'
        },
        //图片高度
        height: {
            type: String,
            default: '100%'
        },
        zoomClass :{
            type: Boolean,
            default: false
        }
    },
    created() {
        this.handleSrcChange(this.src)
    },
    methods:{
        handleSrcChange(src){
            let tenantInfo = this.$store.getters.tenantInfo
            let finalImg = this.src ? this.src : ( this.defaultSrc ? this.defaultSrc : tenantInfo.logo )
            this.finalSrcImg = finalImg.split(',')[0]
        }
    }
}
</script>

<style scoped>
.default-image-box{
    overflow: hidden;
}
.default-image-box img{
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
}
</style>